import i18nProvider from '@/translate/i18nProvider';

export default {
  state: () => ({
    bearerToken: undefined,
    locale: undefined,
  }),
  mutations: {
    setBearerToken(state, newKey) {
      state.bearerToken = newKey;
    },
    setLocale(state, locale) {
      state.locale = locale;
    },
  },
  getters: {
    getBearerToken(state) {
      return state.bearerToken;
    },
  },
  actions: {
    setConfig(context, configValues) {
      const bearerToken = btoa(`${configValues.applicationName}:${configValues.accessToken}`);
      context.commit('setBearerToken', bearerToken);
      context.commit('setLocale', configValues.locale);
      if (window?.pos?.messages) {
        i18nProvider.mergeLocaleMessage(i18nProvider.locale, window.pos.messages);
      }
    },
  },
};
